import { EdbCategoryDayMode as ApiEdbCategoryDayMode, EdbCurrencyID as ApiEdbCurrencyID } from './api'
import type { IconName } from './icon'
import type { SortRuleEnum, GetProductsReqParamsWithTags } from './product'

export interface GetFiltersReqParams {
  region_id: number
  category_id?: string
  sub_category_id?: string
  currency_id?: string
  show_category_filter?: boolean
}

export enum FilterTypeEnum {
  SORTBY = 'sortby',
  NOW = 'now',
  DATE = 'date',
  FILTER_TIME = 'filter_time',
  LIMIT = 'limit',
  PRICE = 'price',
  MIN_PRICE = 'min_price',
  MAX_PRICE = 'max_price',
  START_TIME = 'starttime',
  END_TIME = 'endtime',
  DISCOUNT = 'min_discount_ratio',
  RATING = 'min_branch_rating',
  CUISINE_TAGS = 'cuisine_tags',
  FILTER_TIMES = 'filter_times',
}

export interface FilterComponentProps extends Partial<GetProductsReqParamsWithTags> {}

export interface FormattedRangeValue {
  values: [Nullable<number>, Nullable<number>]
  label?: string
  content?: string
}

export interface FormattedPriceValue extends FormattedRangeValue {
  minPrice?: Nullable<number>
  maxPrice?: Nullable<number>
}

export interface FilterComponentState {
  [FilterTypeEnum.SORTBY]: SortRuleEnum
  [FilterTypeEnum.NOW]: 0 | 1
  [FilterTypeEnum.DATE]: Nullable<string>
  [FilterTypeEnum.LIMIT]: number
  [FilterTypeEnum.PRICE]: FormattedPriceValue['values']
  [FilterTypeEnum.DISCOUNT]: number
  [FilterTypeEnum.RATING]: number
  [FilterTypeEnum.FILTER_TIMES]: string[]
  [FilterTypeEnum.CUISINE_TAGS]?: number[]
  [key: string]: unknown
}

export enum FilterUiTypeEnum {
  CHECK_BOX = 'checkbox',
  RADIO = 'radio',
  RADIO_BUTTON = 'radio-button',
  DATE_RANGE = 'date-range',
  RANGE = 'range',
  MARK_RANGE = 'mark-range',
  SELECT = 'select',
  TIME_PICKER = 'time-picker',
}

export const DayModeCountMap: Record<ApiEdbCategoryDayMode, number> = {
  [ApiEdbCategoryDayMode.CategoryDayModeDefault]: 7,
  [ApiEdbCategoryDayMode.CategoryDayModeCalendar]: 30,
  [ApiEdbCategoryDayMode.CategoryDayModeCalendar180Days]: 180,
  [ApiEdbCategoryDayMode.CategoryDayModeCalendar60Days]: 60,
  [ApiEdbCategoryDayMode.CategoryDayModeCalendar90Days]: 90,
  [ApiEdbCategoryDayMode.CategoryDayModeCalendar365Days]: 365,
}

// 幣別ID 0: 台幣, 1: 港幣, 2: 日幣, 3: 馬幣, 4: 泰銖, 20: 披索, 21: 新幣
export enum CurrencyEnum {
  TWD = ApiEdbCurrencyID.CurrencyIDTWD,
  HKD = ApiEdbCurrencyID.CurrencyIDHKD,
  JPY = ApiEdbCurrencyID.CurrencyIDJPY,
  MYR = ApiEdbCurrencyID.CurrencyIDMYR,
  THB = ApiEdbCurrencyID.CurrencyIDTHB,
  PHP = 20,
  SGD = 21,
}

/**
 * filter tag 之後會在各個環境同步
 * @reference: https://zoeknow.atlassian.net/browse/ZOEKIT-11423
 */
export enum FilterTagIdEnum {}
export interface BaseQueryStringFilterState {
  sortby?: SortRuleEnum
  filter_time?: string
  limit?: number
  discount?: number
  min_branch_rating?: number
  min_price?: number
  max_price?: number
  starttime?: string
  endtime?: string
  filter_times?: string[]
}
export interface QueryStringFilterState extends BaseQueryStringFilterState {
  [key: string]: unknown
}

export interface FilterLayout {
  name: string
  clearable?: boolean
  label?: string
  icon?: IconName
  type?: FilterUiTypeEnum
}
